import React from "react";
import HelmetComponent from "./HelmetComponent";
import HelpArticlesModal from "../components/commenComponents/HelpArticlesModal";

function HelpArticles(props) {
  return (
    <div className=" min-h-screen">
      <HelmetComponent
        title="Akerayu | Help Center: Find Answers to Your Questions"
        description="Akerayu: Your questions, answered. Our FAQs cover everything you need to know about using Akerayu."
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/help"
        type="website"
        robots="index, follow"
      />

      <div className="w-6/12 max-sm:w-11/12 max-md:w-10/12 max-lg:w-8/12 m-auto">
        <HelpArticlesModal />
      </div>
    </div>
  );
}

export default HelpArticles;
